var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"titleWrap":"_3WPKF"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3WPKF{margin-top:10px;margin-bottom:25px;display:inline-block}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

